/**
 * Smart Romanian date range formatter.
 * Avoids duplicating month/year when both dates share them.
 *
 * Examples:
 *  "2026-06-06" / "2026-06-07"  →  "6-7 Iunie 2026"
 *  "2026-06-30" / "2026-07-02"  →  "30 Iunie - 2 Iulie 2026"
 *  "2025-12-30" / "2026-01-02"  →  "30 Decembrie 2025 - 2 Ianuarie 2026"
 *  single day                   →  "6 Iunie 2026"
 */
export const MONTHS_RO = [
  "Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie",
  "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie",
];

export const formatSmartDate = (dateFrom, dateTo) => {
  if (!dateFrom) return "";
  const from = new Date(dateFrom);
  if (isNaN(from.getTime())) return "";

  const fromDay = from.getDate();
  const fromMonth = from.getMonth();
  const fromYear = from.getFullYear();

  if (!dateTo) return `${fromDay} ${MONTHS_RO[fromMonth]} ${fromYear}`;

  const to = new Date(dateTo);
  if (isNaN(to.getTime())) return `${fromDay} ${MONTHS_RO[fromMonth]} ${fromYear}`;

  const toDay = to.getDate();
  const toMonth = to.getMonth();
  const toYear = to.getFullYear();

  // Same month and year — "6-7 Iunie 2026"
  if (fromYear === toYear && fromMonth === toMonth) {
    if (fromDay === toDay) return `${fromDay} ${MONTHS_RO[fromMonth]} ${fromYear}`;
    return `${fromDay}-${toDay} ${MONTHS_RO[fromMonth]} ${fromYear}`;
  }

  // Same year, different months — "30 Iunie - 2 Iulie 2026"
  if (fromYear === toYear) {
    return `${fromDay} ${MONTHS_RO[fromMonth]} - ${toDay} ${MONTHS_RO[toMonth]} ${fromYear}`;
  }

  // Different years — "30 Decembrie 2025 - 2 Ianuarie 2026"
  return `${fromDay} ${MONTHS_RO[fromMonth]} ${fromYear} - ${toDay} ${MONTHS_RO[toMonth]} ${toYear}`;
};
